import type { LevelDefinition } from '../world/LevelDefinition';

const surfaces = {
  floor: { enabled: true, magnetic: true },
  ceiling: { enabled: true, magnetic: true },
  left: { enabled: true, magnetic: true },
  right: { enabled: true, magnetic: true },
  front: { enabled: true, magnetic: true },
  back: { enabled: true, magnetic: true },
};

/**
 * Shuttle Bay: one tall room with two rows of load-bearing pillars, a central
 * landing lane and plenty of vertical space for wall and ceiling fights.
 */
export const SHUTTLE_BAY: LevelDefinition = {
  id: 'shuttle-bay',
  name: 'Shuttle Bay',
  size: [28, 14, 24],
  surfaces,
  spawn: { surface: 'floor', position: [0, 0, 9], facing: 0 },
  targets: [
    { type: 'drone', surface: 'floor', position: [0, 0, -8] },
    { type: 'drone', surface: 'floor', position: [-8, 0, 2] },
    { type: 'drone', surface: 'ceiling', position: [0, 14, 0] },
    { type: 'drone', surface: 'left', position: [-14, 6, 4] },
    { type: 'drone', surface: 'right', position: [14, 6, -4] },
    { type: 'drone', surface: 'back', position: [6, 6, 12] },
    { type: 'drone', surface: 'back', position: [-6, 10, 12] },
  ],
  obstacles: [
    // Two rows of full-height pillars create lanes and cover.
    { type: 'box', kind: 'pillar', position: [8, 7, -8], size: [2, 14, 2] },
    { type: 'box', kind: 'pillar', position: [8, 7, -1], size: [2, 14, 2] },
    { type: 'box', kind: 'pillar', position: [8, 7, 6], size: [2, 14, 2] },
    { type: 'box', kind: 'pillar', position: [-8, 7, -8], size: [2, 14, 2] },
    { type: 'box', kind: 'pillar', position: [-8, 7, -1], size: [2, 14, 2] },
    { type: 'box', kind: 'pillar', position: [-8, 7, 6], size: [2, 14, 2] },
    // Low consoles are jumpable cover.
    { type: 'box', kind: 'console', position: [4.2, 0.55, 2], size: [2.4, 1.1, 0.9] },
    { type: 'box', kind: 'console', position: [-4.2, 0.55, -5], size: [2.4, 1.1, 0.9] },
    { type: 'box', kind: 'crate', position: [2.5, 0.7, -10], size: [1.4, 1.4, 1.4] },
  ],
  style: {
    wallColor: 0x2a3038,
    floorColor: 0x1d232c,
    ceilingColor: 0xc9d6e2,
    pathColor: 0xffb347,
    path: [
      { from: [0, 11], to: [0, -11], width: 3.2 },
      { from: [-11, -2], to: [11, -2], width: 1.6 },
    ],
    ceilingLights: [
      { position: [-6, 13.9, -8], size: [2.4, 0.08, 1.4] },
      { position: [0, 13.9, -8], size: [2.4, 0.08, 1.4] },
      { position: [6, 13.9, -8], size: [2.4, 0.08, 1.4] },
      { position: [-6, 13.9, 0], size: [2.4, 0.08, 1.4] },
      { position: [0, 13.9, 0], size: [2.4, 0.08, 1.4] },
      { position: [6, 13.9, 0], size: [2.4, 0.08, 1.4] },
      { position: [-6, 13.9, 8], size: [2.4, 0.08, 1.4] },
      { position: [0, 13.9, 8], size: [2.4, 0.08, 1.4] },
      { position: [6, 13.9, 8], size: [2.4, 0.08, 1.4] },
    ],
  },
  seed: 4097,
};
